/**
 * toKebabCase converts a string to kebab-case.
 */
export const toKebabCase = (str: string) => {
  return str
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/\s+/g, '-')
    .toLowerCase();
};

const ROLE_NAME_DISPLAY: Record<string, string> = {
  'Organization Owner': 'Organisation Owner',
  'Referring Partner Admin': 'Partner Admin',
};

/**
 * formatRoleName returns the display label for a backend role name.
 * Backend role names are seeded by the API (api/store/seed/constant.go); this
 * translates display only — comparisons against role names elsewhere must keep
 * using the backend value.
 */
export const formatRoleName = (name: string | undefined | null) =>
  (name && ROLE_NAME_DISPLAY[name]) || name || '';
